import {
  GOVUKInitAll,
  ClearCookies,
} from "dvla-external-frontend";
import formUtils from "./js-form-utils";

require.context('./stylesheets/', true, /^\.\/[^_].*\.(css|scss|sass)$/i);
// ensure images are included in the compiled pack
require.context('./images', true);
// ensure dvla-external-frontend/dist/media are included in the compiled pack for favicon, fonts etc
require.context('dvla-external-frontend/dist/media', true);

GOVUKInitAll();
ClearCookies.init();

window.onload = () => {
  formUtils.registerInputListeners();

  const errorSummary = document.querySelector('.govuk-error-summary');
  if (errorSummary) {
    errorSummary.focus();
  }
};
